// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as StringCodec from "lumi-rescript/lib/es6/src/StringCodec.res.js";
import * as MacAddress$IP from "ip/lib/es6/src/MacAddress.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

let options = [
  "ImageCameraDayNightModeColor",
  "ImageCameraDayNightModeBW",
  "ImageCameraDayNightModeAuto",
  "ImageCameraDayNightModeExternalBW",
  "ImageCameraDayNightModeSchedule"
];

let stringCodec = StringCodec.anySumAsString(options, __x => __x.substring("ImageCameraDayNightMode".length));

let jsonCodec = LumiJzon.stringCodec(stringCodec);

let ImageCameraDayNightMode = {
  options: options,
  stringCodec: stringCodec,
  jsonCodec: jsonCodec
};

let options$1 = [
  "ImageWhiteBalanceModeManual",
  "ImageWhiteBalanceModeAWC",
  "ImageWhiteBalanceModeATW",
  "ImageWhiteBalanceModeOutdoor",
  "ImageWhiteBalanceModeIndoor",
  "ImageWhiteBalanceModeMercury",
  "ImageWhiteBalanceModeSodium",
  "ImageWhiteBalanceModeNarrowATW"
];

let stringCodec$1 = StringCodec.anySumAsString(options$1, __x => __x.substring("ImageWhiteBalanceMode".length));

let jsonCodec$1 = LumiJzon.stringCodec(stringCodec$1);

let ImageWhiteBalanceMode = {
  options: options$1,
  stringCodec: stringCodec$1,
  jsonCodec: jsonCodec$1
};

let options$2 = [
  "ImageFlipRotate0",
  "ImageFlipRotate90",
  "ImageFlipRotate270"
];

let stringCodec$2 = StringCodec.anySumAsString(options$2, __x => __x.substring("ImageFlipRotate".length));

let jsonCodec$2 = LumiJzon.stringCodec(stringCodec$2);

let ImageFlipRotate = {
  options: options$2,
  stringCodec: stringCodec$2,
  jsonCodec: jsonCodec$2
};

let options$3 = [
  "ImageSSDRDynamicRangeNarrow",
  "ImageSSDRDynamicRangeWide"
];

let stringCodec$3 = StringCodec.anySumAsString(options$3, __x => __x.substring("ImageSSDRDynamicRange".length));

let jsonCodec$3 = LumiJzon.stringCodec(stringCodec$3);

let ImageSSDRDynamicRange = {
  options: options$3,
  stringCodec: stringCodec$3,
  jsonCodec: jsonCodec$3
};

let options$4 = [
  "ImageIRledModeOff",
  "ImageIRledModeOn",
  "ImageIRledModeSensor",
  "ImageIRledModeSchedule",
  "ImageIRledModeManual",
  "ImageIRledModeAuto",
  "ImageIRledModeAuto1",
  "ImageIRledModeAuto2"
];

let stringCodec$4 = StringCodec.anySumAsString(options$4, __x => __x.substring("ImageIRledMode".length));

let jsonCodec$4 = LumiJzon.stringCodec(stringCodec$4);

let ImageIRledMode = {
  options: options$4,
  $$default: "ImageIRledModeAuto",
  stringCodec: stringCodec$4,
  jsonCodec: jsonCodec$4
};

let options$5 = [
  "SystemDateSyncTypeNTP",
  "SystemDateSyncTypeManual",
  "SystemDateSyncTypeGPS"
];

let stringCodec$5 = StringCodec.anySumAsString(options$5, __x => __x.substring("SystemDateSyncType".length));

let jsonCodec$5 = LumiJzon.stringCodec(stringCodec$5);

let SystemDateSyncType = {
  options: options$5,
  stringCodec: stringCodec$5,
  jsonCodec: jsonCodec$5
};

function parseMacFromQrText(text) {
  let groups = text.split(";");
  let mbMacGroup = groups[2];
  return Stdlib_Option.flatMap(mbMacGroup, macText => MacAddress$IP.fromString(macText.toLowerCase().replaceAll("-", ":")));
}

export {
  ImageCameraDayNightMode,
  ImageWhiteBalanceMode,
  ImageFlipRotate,
  ImageSSDRDynamicRange,
  ImageIRledMode,
  SystemDateSyncType,
  parseMacFromQrText,
}
/* stringCodec Not a pure module */
